import HourglassIcon from '@jetbrains/icons/hourglass.svg'
import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import plur from 'plur'
import {memo} from 'react'

import useFlash from '../../../../hooks/useFlash'
import {getHasTriggeredByMeBuilds} from '../../../../selectors'
import type {BuildTypeId} from '../../../../types'
import RowGroup from '../../Grid/RowGroup'

import styles from './QueuedToggler.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  show: boolean
  count: number
  onToggle: () => unknown
  buildTypeId: BuildTypeId | null | undefined
  containerClassName?: string
  buttonClassName?: string
}

function QueuedToggler({
  show,
  count,
  buildTypeId,
  onToggle,
  containerClassName,
  buttonClassName,
}: Props) {
  const flash = useFlash([count])
  const hasTriggeredByMeBuilds = useAppSelector(state =>
    getHasTriggeredByMeBuilds(state, buildTypeId),
  )
  const buttonClasses = classNames(buttonClassName, {
    [styles.flash]: flash,
    [styles.extraHighlight]: !show && hasTriggeredByMeBuilds,
  })
  return (
    <RowGroup>
      <div className={containerClassName}>
        <Button
          className={buttonClasses}
          iconClassName={styles.queuedIcon}
          onClick={onToggle}
          icon={HourglassIcon}
        >
          {`${show ? 'Hide' : 'Show'} ${count} ${plur('build', count)} in queue`}
        </Button>
      </div>
    </RowGroup>
  )
}

export default memo(QueuedToggler)
